import { createMapStore } from "openchat-client";
import { writable } from "svelte/store";
export const proposalVotes = createMapStore(writable(new Map()));
